import { main } from 'pyright-internal/pyright';

main();
